<app-list-header [headerName]="headerName"></app-list-header>
<section class="content">
    <mat-tab-group animationDuration="1ms">
        <mat-tab *ngIf="is_student" label="Уроки">
            <app-lessons-list
                [lessonStatus]="lesson_statuses.LESSON_CREATED"
                [onlyStatuses]="[lesson_statuses.LESSON_CREATED, lesson_statuses.LESSON_IN_WORK]">
            </app-lessons-list>
        </mat-tab>
        <mat-tab *ngIf="is_student" label="Награды"></mat-tab>
        <mat-tab *ngIf="is_student" label="Банк">
            <div>
                На вашем счету: {{ student_amount }}
            </div>
            <br>
            <div class="account__transactions">
                <app-account-transactions [account]="studentAccount"></app-account-transactions>
            </div>
        </mat-tab>
        <mat-tab *ngIf="is_student" label="Статистика">
            <app-lessons-list
                [lessonStatus]="lesson_statuses.LESSON_COMPLETED"
                [onlyStatuses]="[lesson_statuses.LESSON_COMPLETED, lesson_statuses.LESSON_COMPLETED_NOT_FINAL]">
            </app-lessons-list>
            <!-- <app-stat-lesson-desc
                [lesson]="lesson"
                [show_second_row]='false'>
            </app-stat-lesson-desc>
            <div class="text-center student_info-title">
                {{ profile.user.last_name }} {{ profile.user.first_name }}
            </div>
            <app-stat-lesson-desc
                *ngIf='individual_data && lesson'
                [lesson]="lesson"
                [avg_amount_speed]="avg_amount_speed"
                [avg_resolve_speed]="avg_resolve_speed"
                [extra_exercise]="individual_data?.lesson_extra_exercise"
                [currency]="currency">
            </app-stat-lesson-desc> -->
        </mat-tab>
        <mat-tab *ngIf="is_parent" label="Мои дети"></mat-tab>
        <mat-tab *ngIf="is_teacher || is_teacher_helper || is_super_user" label="Мои классы"></mat-tab>
    </mat-tab-group>
</section>
